import '../css/common.css'
import '../css/app.css'
import '../css/main.css'
import { useState } from 'react';
import { Link, useNavigate } from "react-router-dom"
import useWindowSize from '../hook/useWindowSize';

function Footer() {
    const { Rwidth, Rheight } = useWindowSize();
    return (
        <footer className={`${Rwidth >= 1300 ? "footer1" : "footer"}`}>
            <div className="footer__inner">
                <div className="footer__left">
                    <strong className="footer__brand">주식회사 빠른</strong>
                    <address className="footer__meta">
                        <span>대표자: 신승일</span>
                        <span>사업자등록번호: 702-81-02684</span>
                        <span>주소: 경기도 김포시 김포한강5로 321,9층908호</span>
                        <span>Email: cjone1414@fp.me.kr</span>
                        <span>Tel: 031-990-8587</span>
                        <span>Fax: 031-991-8587</span>
                    </address>
                </div>
                <div className="footer__right">©2025 HappyBridge Corp. All rights reserved.</div>
            </div>
        </footer>

    )
}

export default Footer;